// extracted by mini-css-extract-plugin
export default {"services":"RenewPriceWithOption-services_KTq0_","priceBox":"RenewPriceWithOption-priceBox_utXD1"};